import Vue from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios';
import store from './store'
import globalMixin from './mixins/globalMixin'
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'vue-range-component/dist/vue-range-slider.css';
import 'bootstrap-vue/dist/bootstrap-vue.css'
import "@/scss/app.scss";

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.mixin(globalMixin)
Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
